import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import cookies from "vue-cookies";
import loadComponet from "@/components/LoadScreen.vue";
import firebase from './plugins/firebase'

Vue.component("load", loadComponet);
Vue.use(cookies);
Vue.$cookies.config("2h");
Vue.use(firebase)
Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
